import { Col, Form, Row } from "antd";
import GeneralInformation from "./GeneralInformation";
import AddressInformation from "./AddressInformation";
import Configurations from "./Configurations";
import SyncStockWarehouse from "./SyncStockWarehouse";
import styled from "styled-components";
import { get } from "lodash";
import RelatedLocationTable from "./RelatedLocationTable";

interface LocationFormTypes {
   isCreate?: boolean;
}

export default function LocationForm({ isCreate }: LocationFormTypes) {   
   return (
      <LocationFormStyles className="mt-5" gutter={[16,  16]}>
         <Col md={16} className="col-flex">
            <GeneralInformation />
            <AddressInformation />
            {/* <Form.Item noStyle shouldUpdate={(p, c) => get(p, 'isOrderProcess') !== get(c, 'isOrderProcess')}>
               {({ getFieldValue }) => {
                  const isOrderProcess = getFieldValue("isOrderProcess");

                  return isOrderProcess && <RelatedLocationTable isCreate={isCreate} isOrderProcess={isOrderProcess} />
               }}
            </Form.Item> */}
            <Form.Item noStyle shouldUpdate={(p, c) => get(p, 'isOrderProcess') !== get(c, 'isOrderProcess')}>
               {({ getFieldValue }) => {
                  const isOrderProcess = getFieldValue("isOrderProcess");

                  return isOrderProcess && <RelatedLocationTable isCreate={isCreate} isOrderProcess={isOrderProcess} />
               }}
            </Form.Item>
         </Col>
         <Col md={8} className="col-flex">
            <Configurations />
            <SyncStockWarehouse />
         </Col>
      </LocationFormStyles>
   )
}

const LocationFormStyles = styled(Row)`
   .col-flex {
      display: flex;
      flex-direction: column;
      gap: 15px;
   }
`